var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-uploader" },
    [
      _vm.imageList
        ? _c("a", { staticClass: "link-btn", on: { click: _vm.onShowImage } }, [
            _c("span", { staticClass: "tip-text" }, [_vm._v("您已上传，")]),
            _vm._v("点击查看")
          ])
        : _c("label", { staticClass: "uploader-btn" }, [
            _vm._v("\n    " + _vm._s(_vm.title) + "\n    "),
            _c("input", {
              ref: "file",
              staticStyle: {
                visibility: "hidden",
                position: "absolute",
                width: "1px",
                height: "1px"
              },
              attrs: {
                multiple: !_vm.options.single,
                type: "file",
                accept: _vm.attrs.accept
              },
              on: {
                change: function($event) {
                  _vm.onFileUpload($event, "init")
                }
              }
            })
          ]),
      _vm._v(" "),
      _c(
        "mt-popup",
        {
          staticClass: "mt-upload-list-popup",
          attrs: { position: "bottom" },
          model: {
            value: _vm.isShowImageList,
            callback: function($$v) {
              _vm.isShowImageList = $$v
            },
            expression: "isShowImageList"
          }
        },
        [
          _c("div", { staticClass: "popup-header" }, [
            _c("div", { on: { click: _vm.onClose } }, [
              _c("i", { staticClass: "vip-icon--close" })
            ]),
            _vm._v(" "),
            _c("div", [
              _vm.addBtnText
                ? _c("label", { staticClass: "uploader-btn" }, [
                    _vm._v(
                      "\n          " + _vm._s(_vm.addBtnText) + "\n          "
                    ),
                    _c("input", {
                      ref: "file",
                      staticStyle: {
                        visibility: "hidden",
                        position: "absolute",
                        width: "1px",
                        height: "1px"
                      },
                      attrs: {
                        multiple: !_vm.options.single,
                        type: "file",
                        accept: _vm.attrs.accept
                      },
                      on: {
                        change: function($event) {
                          _vm.onFileUpload($event, "add")
                        }
                      }
                    })
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("label", { staticClass: "uploader-btn reupload" }, [
                _vm._v("\n          重新上传\n          "),
                _c("input", {
                  ref: "file",
                  staticStyle: {
                    visibility: "hidden",
                    position: "absolute",
                    width: "1px",
                    height: "1px"
                  },
                  attrs: {
                    multiple: !_vm.options.single,
                    type: "file",
                    accept: _vm.attrs.accept
                  },
                  on: {
                    change: function($event) {
                      _vm.onFileUpload($event, "new")
                    }
                  }
                })
              ])
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "uploader-list" }, [
            _c(
              "ul",
              { staticClass: "image-list" },
              [
                _vm._l(_vm.imageList, function(image, key) {
                  return _c("li", { key: key }, [
                    _c("img", {
                      directives: [
                        {
                          name: "image-preview",
                          rawName: "v-image-preview",
                          value: { src: image.fileUrl },
                          expression: "{src: image.fileUrl}"
                        },
                        {
                          name: "lazy",
                          rawName: "v-lazy",
                          value: image.fileUrl,
                          expression: "image.fileUrl"
                        }
                      ],
                      staticClass: "uploader-img"
                    })
                  ])
                }),
                _vm._v(" "),
                _c(
                  "li",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.locked,
                        expression: "locked"
                      }
                    ]
                  },
                  [_c("mt-spinner", { attrs: { type: "snake" } })],
                  1
                ),
                _vm._v(" "),
                !_vm.imageList
                  ? _c("div", { staticClass: "no-file" }, [
                      _vm._v("暂无上传文件")
                    ])
                  : _vm._e()
              ],
              2
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1142c55e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1142c55e","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/uploader.vue
// module id = 594
// module chunks = 14